export function requiresAuth(authService) {
  'ngInject';

  return {
    link: link,
    priority: 1000,
    restrict: 'A',

    // The terminal property tells Angular to skip all directives
    // on that element that comes after it (lower priority).
    terminal: true,
    transclude: 'element',
  };

  function link(scope, element, attrs, ctrl, transclude) {
    // I keep track of the currently-injected element and its defined
    // scope. We need the injected element to have its own scope so we
    // can destroy it when we remove the element.
    var cloneElement = null;
    var cloneScope = null;
    // When the model changes, adjust the element existence.
    scope.$watch(
      () => authService.isAuthenticated(),
      (isAuthenticated) => {
        // If we have an existing item, remove it.
        if (cloneElement) {
          // ***************************************************
          // NOTE: We are removing the element AFTER we are
          // destroying the scope associated with the element.
          // ***************************************************
          cloneScope.$destroy();
          cloneScope = null;
          cloneElement.remove();
          cloneElement = null;
        }
        // If the new value is truthy, inject the element.
        if (isAuthenticated) {
          cloneScope = scope.$new();
          cloneElement = transclude(cloneScope, (clone) =>
            element.after(clone),
          );
        }
      },
    );
  }
}
